import { SearchState } from '../types';

const resetSearchReducer = (state: SearchState) => {
  state.results.products = [];
  state.totalFetched = 0;
  state.offset = 99999;
  state.totalAvailable = 0;
};

export default resetSearchReducer;
